/**
 * §5.12: the document's declared language is a page string too.
 *
 * `index.html` ships `lang="hu"`, which is right for the first frame and
 * wrong the moment a customer switches to English or lands on one of §9.4's
 * pages with `?lang=en`. A screen reader picks its voice from this attribute,
 * so an English page left declared Hungarian is read aloud in Hungarian; and
 * `hu-copy` counts the attribute as a string the EN switch has to turn.
 *
 * `langFromSearch` is the other half. The ordering page keeps its language in
 * state, because the switch is in its own header; every other route arrives
 * by a redirect and so takes its language from the query string. The ordering
 * page reads it too, so that *Vissza a rendeléshez* on the §9.4 return page
 * does not drop an English customer back into Hungarian.
 */

import { useEffect } from 'react'

import type { Lang } from './lang.ts'

export function useDocumentLang(lang: Lang): void {
  useEffect(() => {
    document.documentElement.lang = lang
  }, [lang])
}

/** `?lang=en` and nothing else; anything absent or unrecognised is Hungarian. */
export const langFromSearch = (search: { get(key: string): string | null }): Lang =>
  search.get('lang') === 'en' ? 'en' : 'hu'
